import {useCallback, useState} from 'react';

import {downloadApplicantPdfProfile} from '../lib/api/v1';

interface Args {
  companyId: string;
  matchId: string;
  onError?: (error: unknown) => void;
  fileName: string;
}

interface Response {
  downloadPdf: () => Promise<void>;
  isLoading: boolean;
}

export const useDownloadPdfProfile = ({companyId, matchId, onError, fileName}: Args): Response => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadPdf = useCallback(async () => {
    setIsLoading(true);
    try {
      const blob = await downloadApplicantPdfProfile(companyId, matchId);
      const pdfBlob = new Blob([blob], {type: 'application/pdf'});

      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error fetching PDF data:', err);
      onError?.(err);
    } finally {
      setIsLoading(false);
    }
  }, [companyId, matchId, onError, fileName]);

  return {downloadPdf, isLoading};
};
